const SpeakingPersonIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-[14px] h-[14px]"
    aria-hidden="true"
  >
    <circle cx="8" cy="7" r="3" />
    <path d="M3 21v-1a5 5 0 0 1 5-5h0a5 5 0 0 1 5 5v1" />
    <path d="M16 8a3 3 0 0 1 0 4" />
    <path d="M19 6a6 6 0 0 1 0 8" />
  </svg>
);

export default SpeakingPersonIcon;
